import * as React from 'react';
import DataTable from "react-data-table-component";
import {Button} from 'reactstrap';
//import {deselectPosition, selectPosition} from "../job/FinishedJobComponent";

interface ICardProps {
  data: any[];
  columns: any[];
  selected: any[];
  inMutant: any[];
  showSelectAll?: false;

  setSelectedRows: (selectedRows: any[]) => void;

  addToCustomMutant: (selectedRows: any[]) => void;
}

function ResiduesTable(props:ICardProps) {

 const prepareAllResiduesData = (data) => {
    var dataList = {};
    var usedList = {};
    data.forEach((residue) => {
        var act = residue["chain"] + residue["position"];
        if(act in dataList){
            dataList[act].push(residue)
            usedList[act] = residue["isLowEnergy"] || residue["isHighEnergy"] || residue["isLowCombined"] || residue["isHighCombined"] || residue["btc"] ? "YES" : usedList[act];
        }
        else{
            dataList[act] = []
            dataList[act].push(residue)
            usedList[act] = residue["isLowEnergy"] || residue["isHighEnergy"] || residue["isLowCombined"] || residue["isHighCombined"] || residue["btc"] ? "YES" : "NO";
        }
    });
    
    var finalData = [];

    Object.keys(dataList).map((idx) => (
        finalData.push({
            chain: dataList[idx][0]["chain"],
            position: dataList[idx][0]["position"],
            residue: dataList[idx][0]["residue"],
            conservationScore: dataList[idx][0]["conservationScore"],
            bfactor: dataList[idx][0]["bfactor"],
            correlationScore: dataList[idx][0]["correlationScore"],
            used: usedList[idx],
            data: dataList[idx]
        })
    ))

    return finalData;
 }

  const handleChange = ({ selectedRows }) => {
    const prevSelectedRows = props.selected ?? [];
    if (selectedRows.length === 0 && prevSelectedRows.length === 0) {
      return;
    }
    if (selectedRows.length === prevSelectedRows.length) {
      const same = selectedRows.every(r => prevSelectedRows.includes(r));
      if (same) {
        return;
      }
    }
    props.setSelectedRows(selectedRows);
  };

  const rowSelectCritera = (row) => {
   return props.selected.includes(row);
  };


  const addToMutant = (row) => {
    props.addToCustomMutant(row);
        console.log('clicked',row);
    };

  const ExpandedComponent = ({ data }) =>  <DataTable
                                                columns={[...props.columns[1], 
                                                    {
                                                      name: "Add to Design",
                                                      cell: (row) => <Button style={{width: "70%",}} onClick={() => addToMutant(row)} disabled= {props.inMutant.some(m => m.position === data.position && m.chain === data.chain)} >+</Button>,
                                                      ignoreRowClick: true,
                                                      button: true,
                                                    }
                                          ]}
                                                data={data.data}
                                                dense
                                                highlightOnHover={true}
                                                selectableRows
                                                selectableRowsSingle={true}
                                                onSelectedRowsChange={handleChange}
                                                selectableRowSelected={rowSelectCritera}
                                            />;

  return (
    <>

      <DataTable
        columns={props.columns[0]}
        data={prepareAllResiduesData(props.data)}
        pagination
        highlightOnHover={true}
        expandableRows expandableRowsComponent={ExpandedComponent}
      />
    </>
  );
    
}

export default ResiduesTable;

